import React, { Fragment, useState } from 'react';
import {
  CustomInput,
  Modal,
  ModalBody,
  Input,
  Label,
  Row,
  Button,
  ButtonGroup,
  Form,
  FormGroup,
  ModalHeader,
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { getGroupID } from '../../../../../helpers/AxiosAPI';

const ContactForm = ({ toggle, visible, item, propertyId, handleSubmit }) => {
  const [contact, setContact] = useState(
    item || {
      groupId: getGroupID(),
      propertyId: propertyId,
      name: '',
      email: '',
      phone: '',
      firstName: '',
      lastName: '',
      salesforceId: '',
      zipCode: '',
      consent: false,
      creator: 'Admin',
    }
  );

  const handleCheck = (e) => {
    setContact({ ...contact, consent: e.target.checked });
  };

  const hadleContactEditChange = (e) =>
    setContact({ ...contact, [e.target.name]: e.target.value });

  const handleSave = () => {
    if (contact.consent === 'Yes' || contact.consent === 'No')
      contact.consent = contact?.consent === 'Yes' ? true : false;
    handleSubmit(contact);
  };

  return (
    <Fragment>
      {' '}
      <Modal toggle={toggle} isOpen={visible}>
        <ModalHeader toggle={toggle}>Contact</ModalHeader>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <Form className="text-left">
                  <FormGroup className="mb-2">
                    <Label>Contact Name</Label>
                    <Input
                      type="text"
                      name="name"
                      onChange={hadleContactEditChange}
                      value={contact?.name}
                      placeholder="Name"
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Contact Phone</Label>
                    <Input
                      type="text"
                      name="phone"
                      onChange={hadleContactEditChange}
                      value={contact?.phone}
                      placeholder="Phone"
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Contact Email</Label>
                    <Input
                      type="text"
                      name="email"
                      onChange={hadleContactEditChange}
                      value={contact?.email}
                      placeholder="Mail"
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Marketing Consent</Label>
                    <CustomInput
                      type="checkbox"
                      id={contact.propertyId}
                      defaultChecked={
                        contact.consent == 'No' || contact.consent == false
                          ? false
                          : true
                      }
                      onChange={(e) => handleCheck(e)}
                    ></CustomInput>
                  </FormGroup>
                </Form>
              </div>
            </Colxx>
          </Row>
          <Colxx md="12" className="text-center mb-2">
            <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
              <Button color="primary" size="xs" onClick={handleSave}>
                Save
              </Button>
              <Button size="xs" color="dark" outline onClick={toggle}>
                Cancel
              </Button>
            </ButtonGroup>
          </Colxx>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default ContactForm;
